// Vendor
import React from 'react';

// Styles
import * as styles from './InfoBox.css';

// Local
import { CloseIcon } from './CloseIcon';

interface InfoBoxProps {
  /** Direction of the arrow */
  arrowDirection?: 'top' | 'right' | 'bottom' | 'left' | 'none';
  /** Callback for when the InfoBox is closed */
  onClose: () => void;
  /** Content of the InfoBox */
  children: React.ReactNode;
}

/**
 * InfoBox is a component that displays information in a box with an optional arrow
 * @param arrowDirection Direction of the arrow
 * @param onClose Callback for when the InfoBox is closed
 * @param children Content of the InfoBox
 * @returns
 * @example
 * <InfoBox arrowDirection="top" onClose={() => {}}>
 *  This is the content of the InfoBox
 * </InfoBox>
 */
const InfoBox = ({ arrowDirection = 'none', onClose, children }: InfoBoxProps) => {
  return (
    <div className={styles.infoBox}>
      <div className={styles.infoBoxContent} {...styles.dataArrowDirection(arrowDirection)}>
        {children}
        <button className={styles.infoBoxClose} onClick={() => onClose()}>
          <CloseIcon width="18px" height="18px" />
        </button>
      </div>
    </div>
  );
};

export default InfoBox;
